import type { ReactNode } from "react";
import { useEffect } from "react";
import { Navigate } from "react-router";
import { toaster } from "@/app";
import { authClient } from "@/lib/auth-client";
import { homePathFor, isStaffRole } from "@/lib/home-path";

function RootOnlyNotice() {
  return (
    <div className="bg-zinc-50">
      <header className="border-b border-zinc-200 bg-white px-6 py-4">
        <h1 className="mx-auto max-w-7xl text-lg font-semibold text-zinc-900">
          Accueil staff ChantierCarré
        </h1>
      </header>
      <main className="mx-auto max-w-7xl px-6 py-8">
        <p className="text-sm text-zinc-600">
          Votre compte a le rôle Administrateur : la liste des chantiers et
          l'annuaire sont réservés au rôle Root. Si vous en avez besoin,
          demandez à un compte Root de changer votre rôle.
        </p>
      </main>
    </div>
  );
}

/**
 * Guards ChantierCarré back-office routes (/staff/*).
 * Staff = root or admin; other roles are sent back to their own home. Every
 * staff page reads /api/admin/*, which is Root only: an Admin account gets a
 * notice instead of pages it cannot load.
 */
export function RequireStaff({ children }: { children: ReactNode }) {
  const session = authClient.useSession();

  const role = session.data?.user?.role;
  const isStaff = isStaffRole(role);

  useEffect(() => {
    if (session.data && !isStaff) {
      // The toast store flushes synchronously, which React refuses in an effect.
      queueMicrotask(() =>
        toaster.create({
          title: "Page inaccessible",
          description:
            "Cette page est réservée aux comptes ChantierCarré. Retour à votre page d'accueil.",
          type: "error",
        }),
      );
    }
  }, [session.data, isStaff]);

  if (!session.data) {
    return null;
  }

  if (!isStaff) {
    return <Navigate to={homePathFor(role)} replace />;
  }

  if (role !== "root") {
    return <RootOnlyNotice />;
  }

  return <>{children}</>;
}
